import { easepick } from './easypick-index';
import { LockPlugin } from '@easepick/lock-plugin';
import { KbdPlugin } from '@easepick/kbd-plugin';
import { RangePlugin } from '@easepick/range-plugin';

import '@easepick/core/dist/index.css';
import '@easepick/lock-plugin/dist/index.css';
import '@easepick/kbd-plugin/dist/index.css';
import '@easepick/range-plugin/dist/index.css';

import './filter-date.scss';

class FilterDate {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-filter-date',
            startAttr: 'start',
            endAttr: 'end',
            valueAttr: 'value'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$filterDate = $element;
        this.$filterDateStart = this.$filterDate.querySelector(`[${this.settings.initAttr}="${this.settings.startAttr}"]`);
        this.$filterDateEnd = this.$filterDate.querySelector(`[${this.settings.initAttr}="${this.settings.endAttr}"]`);
        this.$filterItems = this.$filterDate.closest('[data-filter="filter"]');
        this.$filter = this.$filterDate.closest('[data-filter="root"]');

        window.setTimeout(() => {
            const filterDateId = this.$filterDate.id;
            this.$filterDateValue = this.$filter.querySelector(`[${this.settings.initAttr}="${this.settings.valueAttr}"][rel="${filterDateId}"]`);
            this.initialize();
        }, 150);
    }

    initialize () {
        const minDateValue = this.$filterDateStart.getAttribute('data-min');

        this.filterDatePicker = new easepick.create({ // eslint-disable-line
            element: this.$filterDateStart,
            inline: true,
            lang: 'de-DE',
            zIndex: 1,
            css: [
                this.$filterDate.getAttribute('data-filter-date-styling')
            ],
            plugins: [LockPlugin, KbdPlugin, RangePlugin],
            LockPlugin: {
                minDate: minDateValue
            },
            KbdPlugin: {
                unitIndex: 0,
                dayIndex: 0
            },
            RangePlugin: {
                elementEnd: this.$filterDateEnd,
                tooltip: false
            },
            setup: (picker) => {
                const filterUpdateEvent = new CustomEvent('change', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });

                picker.on('select', () => {
                    if (this.$filterItems) {
                        this.$filterItems.dispatchEvent(filterUpdateEvent);
                    }
                });

                picker.on('clear', () => {
                    if (this.$filterItems) {
                        this.$filterItems.dispatchEvent(filterUpdateEvent);
                    }
                });
            }
        });

        this.setEvents();
    }

    setEvents () {
        if (this.$filterDateValue) {
            this.$filterDateValue.addEventListener('click', () => {
                this.filterDatePicker.clear();
            });
        }
    }
}

export { FilterDate };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$filterDate = $context.querySelectorAll('[data-filter-date="root"]:not([data-init="true"])');
        for (let i = 0; i < $$filterDate.length; i++) {
            const $filterDate = $$filterDate[i];

            const filterDateAPI = new FilterDate($filterDate);
            $filterDate.API = filterDateAPI;
            $filterDate.setAttribute('data-init', 'true');
        }
    }
});
